module.exports = __webpack_public_path__ + "img/access.72792754.png";